// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import firebase from 'firebase'
import {config} from './helpers/firebaseConfig'
import {user} from './helpers/user'
import moment from 'moment'

Vue.use(VueMaterial)

Vue.config.productionTip = false

firebase.initializeApp(config);

Vue.directive('title', {
  inserted: (el, binding) => document.title = binding.value,
  update: (el, binding) => document.title = binding.value
});

Vue.filter('formatTimestamp', function(value, src) {
  if (value) {
    return moment.unix(value).format('DD/MM/YYYY HH:mm:ss')
  }
});

Vue.filter('formatDate', function(value, src) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
});

Vue.filter('msToSec', function(value, src) {
  if (value) {
    return value/1000
  }
});

new Vue({
  el: '#app',
  router,
  created() {
    firebase.auth().onAuthStateChanged((liuser) => {
      if (liuser) {
        console.log('User logged in!');
        user.init(firebase.auth().currentUser);
      } else {
        this.$router.push('/auth')
      }
     });
    },
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js